import React, { useEffect, useRef } from "react";
import { InputAdornment, makeStyles, OutlinedInput } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import debounce from 'lodash.debounce';

import inputSearchStyle from "./inputSearchStyle";

const useStyles = makeStyles((theme) => inputSearchStyle(theme));

const InputSearch = ({ getProduct }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(undefined);

  const debouncedSave = useRef(debounce(val => getProduct(val), 500)).current;

  useEffect(() => {
    if (typeof value !== "undefined") debouncedSave(value);
  }, [value, debouncedSave]);

    return (
        <OutlinedInput
            className={classes.inputSell}
            id="input-with-icon-adornment"
            placeholder="nome/código do produto"
            startAdornment={
                <InputAdornment position="start">
                    <SearchIcon />
                </InputAdornment>
            }
            onChange={({target}) => setValue(target.value)}
        />
    );
};

export default InputSearch;
